<template>
  <v-app>
    <div class="main-container page-wrap">
      <div id="app" class="app-container">
        <router-view />
      </div>
    </div>
  </v-app>
</template>

<script>
// import { appActions } from '@/constants/'

export default {
  name: 'app',
  components: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
</style>
